import styled from 'styled-components';
import { Box } from 'rebass/styled-components';
import { WRAPPER_SIZE } from '../../theme/style-helpers';

export const Header = styled(Box)`
  text-align: ${({ textAlignment }) => textAlignment};
  max-width: ${WRAPPER_SIZE}px;
`;
